import { useEffect, useState } from "react";
import api, { fmtDateTime } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div><h1 className="text-3xl font-heading font-bold tracking-tight">Auditoría del Sistema</h1><p className="text-muted-foreground text-sm">Registro histórico imborrable de actividad.</p></div>
      <Card className="rounded-lg overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>Fecha/Hora</TableHead><TableHead>Usuario</TableHead><TableHead>Rol</TableHead><TableHead>Acción</TableHead><TableHead>Detalle</TableHead><TableHead>IP</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map((a) => (
              <TableRow key={a.id} data-testid="audit-row">
                <TableCell className="text-xs whitespace-nowrap">{fmtDateTime(a.timestamp)}</TableCell>
                <TableCell className="text-sm">{a.user_name}</TableCell>
                <TableCell><Badge variant="secondary" className="text-xs">{a.role}</Badge></TableCell>
                <TableCell className="text-sm font-medium">{a.action}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{a.details}</TableCell>
                <TableCell className="text-xs font-mono">{a.ip}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-8">Sin registros.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
